import { z } from 'zod';

/**
 * Shared form schema for InviteMemberDialog and ShareProfileDialog (MYN-43/54):
 * both collect a required full name plus a required, valid email address.
 */
export const inviteFormSchema = z.object({
  fullName: z.string().trim().min(1, 'Full name is required').max(200),
  email: z.string().trim().min(1, 'Email is required').email('Enter a valid email address'),
});

export type InviteFormValues = z.infer<typeof inviteFormSchema>;
